import { render, staticRenderFns } from "./adoria.vue?vue&type=template&id=db2f1d9a&"
import script from "./adoria.vue?vue&type=script&lang=ts&"
export * from "./adoria.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports